import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dialog, FlatButton } from 'material-ui';
import style from '../../../styles/styles';
import Loading from '../../../components/common/Loading/Loading';
import { getAdmins, deleteAdmin } from '../../../store/admins/actions';
import Application from '../../../components/application/BlockApplication/BlockApplication';
import styles from './DashboardPage.css';
import AdminService, { SUPER_ADMIN } from '../../../services/admin';
import { getApps, resetApp } from '../../../store/apps/actions';
import { resetPoints } from '../../../store/points/actions';
import { resetTrails } from '../../../store/trails/actions';
import { resetTypes } from '../../../store/types/actions';
import { resetComments } from '../../../store/comments/actions';
import { resetCustomFields } from '../../../store/customfields/actions';
import withTranslation from '../../../hoc/withTranslation';
import AdminBoard from '../../../components/admin/AdminBoard/AdminBoard';

export class DashboardPage extends React.Component {

    static propTypes = {
        getApps: PropTypes.func,
        getAdmins: PropTypes.func,
        deleteAdmin: PropTypes.func,
        resetComments: PropTypes.func,
        resetCustomFields: PropTypes.func,
        resetTypes: PropTypes.func,
        resetApp: PropTypes.func,
        resetPoints: PropTypes.func,
        resetTrails: PropTypes.func,
        t: PropTypes.func,
        user: PropTypes.object,
        authenticated: PropTypes.bool,
        appsLoading: PropTypes.bool,
        apps: PropTypes.array,
        admins: PropTypes.array,
        adminsLoading: PropTypes.bool,
        adminsSending: PropTypes.bool,
    };

    state = {
        openRemoveAdmin: false,
        adminToRemove: null,
    };

    componentWillMount() {
        if (this.props.apps !== null && this.props.apps.length > 0) {
            this.props.resetApp();
            this.props.resetPoints();
            this.props.resetTrails();
            this.props.resetTypes();
            this.props.resetComments();
            this.props.resetCustomFields();
        }
        if (AdminService.isAuthorized(SUPER_ADMIN, this.props.user)) {
            this.props.getAdmins();
        }
        this.props.getApps();
    }

    componentWillUpdate(nextProps) {
        if (this.props.apps === null && !this.props.appsLoading) {
            this.props.getApps();
        }
        if (this.props.adminsSending && !nextProps.adminsSending) {
            if (this.state.adminToRemove) { // admin has been deleted
                this.handleCloseAdmin();
                this.props.getAdmins();
            }
        }
    }

    // Delete admin

    handleDeleteAdmin = (admin) => {
        this.setState({
            openRemoveAdmin: true,
            adminToRemove: admin,
        });
    };

    handleCloseAdmin = () => {
        this.setState({
            openRemoveAdmin: false,
            adminToRemove: null,
        });
    };

    deleteAdmin = () => {
        this.props.deleteAdmin(this.state.adminToRemove);
    };

    renderDeleteAdminDialog(admin) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.adminsSending}
                onClick={this.handleCloseAdmin}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.adminsSending}
                onClick={this.deleteAdmin}
            />,
        ];

        return (
            <Dialog
                title={this.props.t('account_page.remove_admin')}
                actions={actions}
                modal={false}
                open={this.state.openRemoveAdmin}
                onRequestClose={this.handleCloseAdmin}
            >
                {this.props.adminsSending && <Loading paper={false} />}
                {!this.props.adminsSending &&
                    <span>
                        <div
                            dangerouslySetInnerHTML={{
                                __html:
                                    this.props.t('account_page.remove_admin_confirmation', {
                                        firstname: admin.firstname,
                                        lastname: admin.lastname,
                                        username: admin.username,
                                    }),
                            }}
                        />
                    </span>
                }
            </Dialog>
        );
    }

    renderApps() {
        let content;

        if (this.props.appsLoading) {
            content = <Loading paper={false} />;
        } else {
            content = this.props.apps.map((app) => {
                return (
                    <div
                        key={app.id} className="col-xs-12 col-sm-6 col-md-3"
                        style={styles.application}
                    >
                        <Application app={app} user={this.props.user} />
                    </div>
                );
            });
        }

        return (
            <div>
                <h3 style={style.navigation}>{this.props.t('generic.dashboard')} / {this.props.t(
                    'generic.application',
                    this.props.apps.length,
                )}</h3>
                <div className="row">
                    {content}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.state.adminToRemove && this.renderDeleteAdminDialog(this.state.adminToRemove)}

                {this.renderApps()}
                {AdminService.isAuthorized(SUPER_ADMIN, this.props.user) && (
                    <div>
                        <h3 style={style.navigation}>{this.props.t('generic.dashboard')} / {this.props.t(
                            'generic.admins')}</h3>
                        <AdminBoard
                            admins={this.props.admins}
                            t={this.props.t}
                            user={this.props.user}
                            handleDeleteAdmin={this.handleDeleteAdmin}
                            loading={this.props.adminsLoading}
                        />
                    </div>
                )}

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.auth.content,
        authenticated: state.auth.authenticated,
        appsLoading: state.apps.pending,
        apps: state.apps.content,
        admins: state.admins.content,
        adminsLoading: state.admins.pending,
        adminsSending: state.admins.sending,
    };
}

DashboardPage.defaultProps = {
    appsLoading: true,
    apps: [],
};

export default connect(mapStateToProps, {
    getApps,
    getAdmins,
    deleteAdmin,
    resetComments,
    resetCustomFields,
    resetTypes,
    resetApp,
    resetPoints,
    resetTrails,
})(withTranslation(DashboardPage));



// WEBPACK FOOTER //
// src/containers/common/DashboardPage/DashboardPage.js